<div class="ab-list-item-inner flex w-100 activity-type--upload">
  <span class="ab-list-item__icon">
    <i class="icon fal fa-file-upload"></i>
  </span>

  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span> created a new upload.
    </div>
    <div class="details">
    </div>
  </div>
  <app-activity-event-timestamp [item]="item" class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
